import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';

import './index.css';
// eslint-disable-next-line
import App from './App';
import GlobalLoadingIndicator from './GlobalLoadingIndicator';
import AzureAuthenticationApollo from 'authentication-apollo/components/MsalWrapper';
import MockAuthWrapper from 'authentication-apollo/components/MockAuthWrapper';
import msalInstance from 'authentication-apollo/msalInit';

//local e2e testing only (see e2e/README.md): REACT_APP_MOCK_AUTH is inlined
//at build time, so production builds keep the MSAL wrapper untouched
const AuthWrapper =
  process.env.REACT_APP_MOCK_AUTH === 'true'
    ? MockAuthWrapper
    : AzureAuthenticationApollo;

ReactDOM.render(
  <AuthWrapper pca={msalInstance}>
    {(activeAccount, logout) => {
      return (
        <React.Fragment>
          <GlobalLoadingIndicator />
          <App account={activeAccount} logout={logout} />
        </React.Fragment>
      );
    }}
  </AuthWrapper>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
